import React from "react";
import "./style.scss";
import SelectMarketplace from "../../../components/Dashboard/SelectMarketplace";
const SelectMarketplacePage = () => {
  return (
    <div className="market_place_main_page_wrapper">
      <SelectMarketplace />
    </div>
  );
};
export default SelectMarketplacePage;
